import { z } from 'zod';
import {
  BaseResponseSchema,
} from './primitives.js';


// ========================================
// Provider Ops — Device Health Reconciliation (Phase 2)
// ========================================

export const LocationDeviceHealthReconciliationSchema = z.object({
  anchorsAssigned: z.number().int().min(0),
  anchorsOnline: z.number().int().min(0),
  anchorsOffline: z.number().int().min(0),
  anchorsUnassignedPoints: z.number().int().min(0),
  anchorsUnassignedHardware: z.number().int().min(0),
  anchorsUnhealthy: z.number().int().min(0),
  tagsSeen: z.number().int().min(0),
  tagsUnregisteredSeen: z.number().int().min(0),
  tagsNeverSeenInInventory: z.number().int().min(0),
  sitesWithFloorPlan: z.number().int().min(0),
});


export const LocationDeviceHealthReconciliationResponseSchema = BaseResponseSchema.extend({
  data: LocationDeviceHealthReconciliationSchema,
});


export const EfemDeviceHealthReconciliationSchema = z.object({
  boundPeripherals: z.number().int().min(0),
  peripheralsHealthy: z.number().int().min(0),
  peripheralsUnreachable: z.number().int().min(0),
  peripheralsUnknown: z.number().int().min(0),
  peripheralsDegraded: z.number().int().min(0),
  adaptersNotReady: z.number().int().min(0),
  gatewaysWithIssues: z.number().int().min(0),
});


export const UnattestedDeviceHealthReconciliationSchema = z.object({
  openAttempts: z.number().int().min(0),
  openAttemptsLast24h: z.number().int().min(0),
});


export const DeviceHealthReconciliationSummarySchema = z.object({
  efem: EfemDeviceHealthReconciliationSchema,
  location: LocationDeviceHealthReconciliationSchema,
  unattested: UnattestedDeviceHealthReconciliationSchema,
  generatedAt: z.string().datetime(),
});


export const DeviceHealthReconciliationResponseSchema = BaseResponseSchema.extend({
  data: DeviceHealthReconciliationSummarySchema,
});
// Inferred types
export type DeviceHealthReconciliationResponse = z.infer<typeof DeviceHealthReconciliationResponseSchema>;
export type DeviceHealthReconciliationSummary = z.infer<typeof DeviceHealthReconciliationSummarySchema>;
export type EfemDeviceHealthReconciliation = z.infer<typeof EfemDeviceHealthReconciliationSchema>;
export type LocationDeviceHealthReconciliation = z.infer<typeof LocationDeviceHealthReconciliationSchema>;
export type LocationDeviceHealthReconciliationResponse = z.infer<typeof LocationDeviceHealthReconciliationResponseSchema>;
export type UnattestedDeviceHealthReconciliation = z.infer<typeof UnattestedDeviceHealthReconciliationSchema>;
